import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {SpinnerState} from './spinner.state.type';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule]
})
export class SpinnerComponent implements OnInit {
  @Input() showSpinner = true;
  @Output() spinnerClicked = new EventEmitter();
  public state: SpinnerState = 'start';

  constructor() { }

  handleSpinnerClick() {
    this.state = 'loading';
    this.spinnerClicked.emit();
  }

  ngOnInit() {
    return;
  }

}
